export const elasticConfig_prod = {};
